import { FC, memo } from "react";

import SquarePlus from "web/assets/icons/square-plus.svg";

import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";

import classes from "./rentableGroupCalculatorAddPerson.scss";

interface IRentableGroupCalculatorAddPersonProps {
  addPersonCopy: string;
  onClick: () => void;
}

const RentableGroupCalculatorAddPerson: FC<IRentableGroupCalculatorAddPersonProps> =
  memo(({ addPersonCopy, onClick }) => {
    return (
      <button type="button" onClick={onClick} className={classes.addPersonBtn}>
        <SquarePlus width={15} />
        <RentableGroupCalculatorHtmlContent
          as="span"
          className={classes.btnText}
          html={addPersonCopy}
        />
      </button>
    );
  });
export default RentableGroupCalculatorAddPerson;
